import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];

export const useApplyReAssessment = (id: string, config?: Config) => {
  return usePostMutation(
    z.undefined(),
    z.null(),
    `/console/re_assessments/${id}/apply`,
    config,
  );
};
